import classNames from 'classnames';
import Tag, { TagProps } from '@/components/molecules/tag/tag';
import styles from './filter-tag-list.module.scss';

export interface FilterItem extends TagProps {
  id: string;
  isSelected: boolean;
}

export interface FilterTagListProps {
  /** The class name to apply */
  className?: string;
  /** An array of the filter cards to show */
  items: FilterItem[];
  /** An event that is triggered on change */
  onChange?: (id: string) => void;
}

const FilterTagList = ({ className, items, onChange }: FilterTagListProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      {items.map(item => (
        <Tag
          key={item.id}
          className={styles.tag}
          onClick={() => onChange && onChange(item.id)}
          text={item.text}
          variant={item.isSelected ? 'primary' : 'secondary'}
        />
      ))}
    </div>
  );
};

FilterTagList.displayName = 'FilterTagList';

export default FilterTagList;
